const industrialProducts = [
  {
    name: "Shell Tellus",
    series: "S2 / S3 / S4",
    type: "Гидравлические масла",
    icon: "ri-settings-3-line",
    badge: "Hydraulic",
    approvals: ["Bosch Rexroth", "Haitian", "Parker", "Eaton Vickers"],
    desc: "Высокоэффективные гидравлические масла для промышленного оборудования. Обеспечивают стабильную работу гидросистем при экстремальных температурах и давлениях.",
    viscosity: ["32", "46", "68", "100"],
    highlight: true,
  },
  {
    name: "Shell Omala",
    series: "S2 G / S4 GX / S4 WE",
    type: "Редукторные масла",
    icon: "ri-tools-line",
    badge: "Gear",
    approvals: ["Flender", "Gamesa", "SEW", "Siemens"],
    desc: "Специализированные масла для промышленных редукторов и зубчатых передач. Синтетические формулы обеспечивают защиту при высоких нагрузках и температурах.",
    viscosity: ["150", "220", "320", "460"],
    highlight: false,
  },
  {
    name: "Shell Corena",
    series: "S2 P / S3 R / S4 P",
    type: "Компрессорные масла",
    icon: "ri-loader-4-line",
    badge: "Compressor",
    approvals: ["ABB VTR", "Atlas Copco", "Ingersoll Rand", "Kaeser"],
    desc: "Масла для воздушных и газовых компрессоров. Обеспечивают длительные интервалы замены и защиту от отложений в турбокомпрессорах ABB VTR.",
    viscosity: ["46", "68", "100"],
    highlight: false,
  },
  {
    name: "Shell Gadus",
    series: "S2 V220 / S3 V460 / S5 T460",
    type: "Консистентные смазки",
    icon: "ri-oil-line",
    badge: "Grease",
    approvals: ["Caterpillar", "Liebherr", "Komatsu", "Volvo CE"],
    desc: "Высококачественные консистентные смазки для тяжёлой техники и промышленного оборудования. Работают в широком диапазоне температур и нагрузок.",
    viscosity: ["NLGI 1", "NLGI 2", "NLGI 3"],
    highlight: false,
  },
];

export default function ShellIndustrialSection() {
  return (
    <section id="shell-industrial" className="bg-[#060A10] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* SEO Header — contains target keywords */}
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">Shell Industrial Lubricants · Белая таможня</span>
          </div>
          <h2 className="text-white mb-5" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(32px, 4.5vw, 60px)", letterSpacing: "0.03em" }}>
            <strong>SHELL INDUSTRIAL LUBRICANTS</strong><br />
            <span className="text-[#C9A84C]">FOR RUSSIA · БЕЛАЯ ТАМОЖНЯ</span>
          </h2>
          <p className="text-gray-400 text-base max-w-3xl leading-relaxed">
            Полный ассортимент промышленных смазочных материалов Shell — гидравлика, редукторы, компрессоры, консистентные смазки. Поставки в Россию через <strong className="text-white">официальную «белую» таможню</strong> с ГТД/НДС и EAC-сертификацией. <strong className="text-[#C9A84C]">Shell Industrial Lubricants for Russia</strong> — прямые поставки из Гонконга.
          </p>
        </div>

        {/* Real Shell Photo Banner — oil bottle full view */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-0 rounded-sm overflow-hidden border border-[#C9A84C]/20 mb-14">
          {/* Left — 208L industrial drum, object-contain, full silhouette visible */}
          <div className="lg:col-span-2 relative bg-[#040810] flex items-center justify-center" style={{ minHeight: "340px" }}>
            <img
              src="https://public.readdy.ai/ai/img_res/556362682ba79261795879965e9e7db3.jpg"
              alt="Shell Industrial Lubricants 208L drum — Shell Tellus Omala Corena Gadus industrial oil barrel Russia белая таможня"
              className="w-full h-full object-contain p-4"
              style={{ maxHeight: "340px" }}
            />
            <div className="absolute top-4 left-4 w-6 h-6 border-t-2 border-l-2 border-[#C9A84C]/50"></div>
            <div className="absolute bottom-4 right-4 w-6 h-6 border-b-2 border-r-2 border-[#C9A84C]/50"></div>
          </div>
          {/* Right — content */}
          <div className="lg:col-span-3 bg-[#0D1420] p-10 flex flex-col justify-center border-t lg:border-t-0 lg:border-l border-[#C9A84C]/20">
            <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.3em] uppercase mb-4">Реальный товар · Склад YAXIN · Гонконг → Россия</div>
            <div className="text-white font-black mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(26px, 3vw, 44px)", letterSpacing: "0.03em", lineHeight: 1.1 }}>
              SHELL INDUSTRIAL<br />
              <span className="text-[#C9A84C]">ГОНКОНГ → РОССИЯ</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Tellus · Omala · Corena · Gadus — полный промышленный ассортимент Shell. Белая таможня, ГТД/НДС, EAC на каждую позицию. Прямые поставки от официального дистрибьютора в Гонконге.
            </p>
            <div className="grid grid-cols-2 gap-3">
              {[
                { name: "Shell Tellus", sub: "Гидравлика · S2/S3/S4" },
                { name: "Shell Omala", sub: "Редукторы · S2G/S4GX" },
                { name: "Shell Corena", sub: "Компрессоры · S2P/S4P" },
                { name: "Shell Gadus", sub: "Смазки · NLGI 1/2/3" },
              ].map((item) => (
                <div key={item.name} className="flex items-center gap-2 bg-[#080C14] border border-[#1E2A3A] px-3 py-2.5 rounded-sm">
                  <div className="w-1.5 h-1.5 bg-[#C9A84C] rounded-full flex-shrink-0"></div>
                  <div>
                    <div className="text-white text-xs font-bold">{item.name}</div>
                    <div className="text-gray-600 text-[10px]">{item.sub}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Industrial Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12">
          {industrialProducts.map((product, idx) => {
            const bgImages = [
              "https://readdy.ai/api/search-image?query=heavy%20industrial%20CNC%20lathe%20machine%20turning%20metal%20workpiece%20in%20factory%2C%20large%20precision%20metal%20lathe%20with%20spinning%20chuck%20and%20cutting%20tool%2C%20industrial%20manufacturing%20workshop%20with%20steel%20machinery%2C%20dramatic%20dark%20moody%20lighting%2C%20close-up%20of%20rotating%20metal%20lathe%20with%20sparks%20and%20coolant%20fluid%2C%20professional%20industrial%20photography%20with%20deep%20shadows%20and%20warm%20metallic%20tones&width=800&height=500&seq=industrial_lathe_tellus&orientation=landscape",
              "https://readdy.ai/api/search-image?query=heavy%20construction%20machinery%20excavator%20and%20bulldozer%20working%20on%20large%20construction%20site%2C%20yellow%20construction%20equipment%20operating%20in%20dusty%20environment%2C%20massive%20hydraulic%20excavator%20arm%20digging%20earth%2C%20industrial%20construction%20scene%20with%20cranes%20and%20heavy%20equipment%20in%20background%2C%20dramatic%20golden%20hour%20lighting%2C%20professional%20industrial%20photography%20with%20rich%20warm%20tones%20and%20deep%20shadows&width=800&height=500&seq=industrial_construction_omala&orientation=landscape",
              "https://readdy.ai/api/search-image?query=large%20industrial%20power%20plant%20electricity%20generation%20facility%2C%20massive%20turbines%20and%20generators%20inside%20power%20station%2C%20industrial%20energy%20production%20with%20huge%20metal%20machinery%20and%20pipes%2C%20dramatic%20interior%20of%20thermal%20power%20plant%20with%20glowing%20equipment%20and%20steam%2C%20professional%20industrial%20photography%20with%20dark%20moody%20atmosphere%20and%20warm%20orange%20lighting%20on%20metal%20surfaces&width=800&height=500&seq=industrial_powerplant_corena&orientation=landscape",
              "https://readdy.ai/api/search-image?query=heavy%20duty%20semi%20truck%20convoy%20on%20highway%20at%20dusk%2C%20massive%20long%20haul%20freight%20trucks%20with%20large%20cargo%20trailers%20driving%20on%20open%20road%2C%20powerful%20diesel%20trucks%20with%20chrome%20details%20and%20bright%20headlights%2C%20dramatic%20low%20angle%20shot%20of%20heavy%20trucks%20on%20empty%20highway%20with%20dramatic%20sky%2C%20professional%20automotive%20photography%20with%20cinematic%20dark%20moody%20tones%20and%20warm%20golden%20light&width=800&height=500&seq=industrial_truck_gadus&orientation=landscape",
            ];
            return (
              <div
                key={product.name}
                className={`relative overflow-hidden rounded-sm border transition-all duration-300 hover:border-[#C9A84C]/50 ${
                  product.highlight ? "border-[#C9A84C]/40" : "border-[#1E2A3A]"
                }`}
              >
                {/* Top image strip — fixed height, light overlay */}
                <div className="relative w-full h-36 overflow-hidden flex-shrink-0">
                  <img
                    src={bgImages[idx]}
                    alt={`${product.type} — Shell ${product.name} industrial application`}
                    className="w-full h-full object-cover object-center"
                  />
                  <div className="absolute inset-0 bg-[#060A10]/30"></div>
                  {/* Badge over image */}
                  <div className="absolute top-3 right-3 bg-[#C9A84C] text-[#0A0F1A] text-[10px] font-black px-2.5 py-1 rounded-sm tracking-widest uppercase">
                    {product.badge}
                  </div>
                </div>

                {/* Content on solid dark background */}
                <div className={`p-7 ${product.highlight ? "bg-gradient-to-br from-[#C9A84C]/8 to-[#0D1420]" : "bg-[#0D1420]"}`}>
                  <div className="flex items-start gap-4 mb-5">
                    <div className="w-14 h-14 flex items-center justify-center border border-[#C9A84C]/30 rounded-sm flex-shrink-0">
                      <i className={`${product.icon} text-[#C9A84C] text-2xl`}></i>
                    </div>
                    <div>
                      <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.2em] uppercase mb-1">{product.type}</div>
                      <h3 className="text-white font-black text-xl" style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: "0.04em" }}>{product.name}</h3>
                      <div className="text-gray-500 text-xs mt-0.5">{product.series}</div>
                    </div>
                  </div>

                  <p className="text-gray-400 text-sm leading-relaxed mb-5">{product.desc}</p>

                  {/* Viscosity grades */}
                  <div className="mb-4">
                    <div className="text-gray-600 text-[10px] font-semibold uppercase tracking-wide mb-2">Вязкость / Классы</div>
                    <div className="flex flex-wrap gap-1.5">
                      {product.viscosity.map((v) => (
                        <span key={v} className="text-[#C9A84C] text-[10px] font-bold bg-[#C9A84C]/10 border border-[#C9A84C]/20 px-2.5 py-1 rounded-sm whitespace-nowrap">
                          {v}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Approvals */}
                  <div>
                    <div className="text-gray-600 text-[10px] font-semibold uppercase tracking-wide mb-2">Одобрено / Совместимо</div>
                    <div className="flex flex-wrap gap-1.5">
                      {product.approvals.map((a) => (
                        <span key={a} className="text-gray-400 text-[10px] bg-[#1E2A3A] px-2 py-0.5 rounded-sm whitespace-nowrap">
                          {a}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="bg-[#0D1420] border border-[#C9A84C]/20 p-8 rounded-sm flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <div className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase mb-2">Shell Industrial Lubricants for Russia · Белая таможня</div>
            <h3 className="text-white font-bold text-xl mb-2" style={{ fontFamily: "'Oswald', sans-serif" }}>
              Запросить прайс-лист на промышленные масла Shell
            </h3>
            <p className="text-gray-400 text-sm">Tellus · Omala · Corena · Gadus — полный ассортимент с ГТД/НДС и EAC</p>
          </div>
          <a
            href="#contact"
            className="flex-shrink-0 inline-flex items-center gap-3 bg-[#C9A84C] hover:bg-[#b8943d] text-[#0A0F1A] font-bold text-sm px-8 py-4 rounded-sm tracking-wide uppercase transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line text-base"></i>
            Запросить B2B прайс-лист
          </a>
        </div>
      </div>
    </section>
  );
}
